import React from 'react';
import { Typography } from '@material-ui/core';
const styles = {
  emoteIcon: {
    width: '36px',
    height: '36px'
  },
  flexHorizontal: {
    display: 'flex',
    justifyCotent: 'space-between',
    alignItems: 'center',
    gap: '0.5rem'
  }
};

// 10/29/2022: Easter egg for KQM Scavenger Hunt
export function KeqingFlower({ userId }) {
  const ChrysUserId = '6263c09ecddbb097a8357bb4';
  if (userId !== ChrysUserId) return <></>;

  const keqingFlowerEmoteURL =
    'https://cdn.discordapp.com/emojis/958387021708136458.webp?size=80&quality=lossless';

  return (
    <span style={styles.flexHorizontal}>
      <Typography style={{ fontSize: '16px', color: 'black' }}>
        F4STK3Q1NG
      </Typography>
      <img src={keqingFlowerEmoteURL} style={styles.emoteIcon} />
    </span>
  );
}
